import Head from 'next/head';

import MyOrders from '../../components/MyOrders';
import { pageTitle } from '../../components/shared/basic/customHead';

const InAppOrders = () => {
  return (
    <div>
      <Head>
        <title>{pageTitle('In App Orders')}</title>
      </Head>
      <MyOrders />
    </div>
  );
};

export default InAppOrders;
